module.exports = __webpack_public_path__ + "assets/e437838a31f167e2c400333f4b90a353.svg";